export const EVENT_FILTER_CONSTANTS = {
    translationsKeys: {
        specialOffer: 'eventFilter.specialOffersLabel',
        filteredPort: 'eventFilter.filteredPortLabel'
    },
    specialOfferNameTemplate: 'specialOffer.{promoCode}.title'
};
